webpackJsonp([255710483106061],{

/***/ 225:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(5);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _ProjectPage = __webpack_require__(9);
	
	var _ProjectPage2 = _interopRequireDefault(_ProjectPage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	//import SinglePicsPage from '../components/SinglePics'
	
	
	var projectElements = {
		images: [{
			"src": "Portraits/vali_6",
			"orientation": "portrait"
		}, {
			"src": "Portraits/vali_10",
			"orientation": "portrait"
		}, {
			"src": "Portraits/vali_11",
			"orientation": "portrait"
		}, {
			"src": "Portraits/vali_12",
			"orientation": "landscape"
		}, {
			"src": "Portraits/vali_8",
			"orientation": "portrait"
		}, {
			"src": "Portraits/vali_9",
			"orientation": "portrait"
		}, {
			"src": "Portraits/vali_7",
			"orientation": "portrait"
		}, {
			"src": "Portraits/julia_3",
			"orientation": "landscape"
		}, {
			"src": "Portraits/julia_1",
			"orientation": "portrait"
		}, {
			"src": "Portraits/julia_2",
			"orientation": "portrait"
		}, {
			"src": "Portraits/julia_5",
			"orientation": "portrait"
		}, {
			"src": "Portraits/julia_4",
			"orientation": "landscape"
		}, {
			"src": "Portraits/lena_3",
			"orientation": "portrait"
		}, {
			"src": "Portraits/lena_1",
			"orientation": "portrait"
		}, {
			"src": "Portraits/lena_4",
			"orientation": "portrait"
		}, {
			"src": "Portraits/lena_2",
			"orientation": "landscape"
		}, {
			"src": "Portraits/vali_3",
			"orientation": "portrait"
		}, {
			"src": "Portraits/vali_4",
			"orientation": "portrait"
		}, {
			"src": "Portraits/vali_1",
			"orientation": "portrait"
		}, {
			"src": "Portraits/vali_5",
			"orientation": "landscape"
		}]
	};
	
	var PortraitPage = function (_React$Component) {
		_inherits(PortraitPage, _React$Component);
	
		function PortraitPage() {
			_classCallCheck(this, PortraitPage);
	
			return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
		}
	
		PortraitPage.prototype.render = function render() {
			return _react2.default.createElement(_ProjectPage2.default, {
				title: 'Portraits',
				text: '',
				images: projectElements.images,
				layout: 'singlesImages' });
		};
	
		return PortraitPage;
	}(_react2.default.Component);
	
	exports.default = PortraitPage;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-portrait-js-bd7995f6d09edc72bc4f.js